import GeneralConfigurationView from "../GeneralConfigurationView.vue";
import GeneralConfigurationPage from "../Pages/GeneralConfigurationPage.vue";

const routes = [
  {
    path: '/general-configuration',
    component: GeneralConfigurationView,
    children: [
      {
        path: '',
        name: 'general-configuration',
        component: GeneralConfigurationPage,
      },
    ]
  }
]

export default routes
